import React, { useState } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// 代码                     //////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 对话框的id( 支持 多重对话框, 使用 stack 维护 )
var id = 0;
var ModalContext = React.createContext({});
var ModalProvider = function (_a) {
    var children = _a.children;
    var _b = useState([]), modalStates = _b[0], _setModalStates = _b[1];
    var modalStatesRef = React.useRef(modalStates);
    var setModalStates = function (states) {
        _setModalStates(states);
        modalStatesRef.current = states;
    };
    // 由于被ModalContext.Provider 使用, openModal 的引用不可变!
    // 所以最终使用了 modalStatesRef
    var openModal = React.useCallback(function (Modal) {
        var p = new Promise(function (resolve, reject) {
            var newModalStates = modalStatesRef.current.concat([
                {
                    id: id++,
                    show: true,
                    Modal: Modal,
                    resolve: resolve,
                    reject: reject
                }
            ]);
            setModalStates(newModalStates);
        }).catch(function (e) {
            if (e.message === 'modal-hided') ;
            else {
                throw e;
            }
        });
        return p;
    }, []);
    // 如果有关闭对话框, 那么仅设置状态, 并记录关闭时间, 留待定时器清除
    var _c = useState(false), needClearExpired = _c[0], setNeedClearExpired = _c[1];
    // 引用可变, 无需使用 modalStatesRef
    var hideModal = React.useCallback(function (id) {
        var idx = modalStates.findIndex(function (state) { return state.id === id; });
        var reject = modalStates[idx].reject;
        var newModalStates = modalStates.slice(0, idx).concat([
            __assign({}, modalStates[idx], { show: false, expiredAt: new Date() })
        ], modalStates.slice(idx + 1));
        setModalStates(newModalStates);
        setNeedClearExpired(true);
        reject(new Error('modal-hided'));
    }, [modalStates]);
    // 如果有关闭对话框 , 那么 5 秒后清除 ( 目的是维持关闭动画 )
    React.useEffect(function () {
        if (!needClearExpired)
            return;
        var timeoutHandler = setTimeout(clearExpiredState, 5000);
        function clearExpiredState() {
            console.log('clear: ');
            var validModalStates = modalStatesRef.current.filter(function (s) {
                return (!s.expiredAt || new Date().getTime() - s.expiredAt.getTime() < 1000);
            });
            setModalStates(validModalStates);
            setNeedClearExpired(false);
        }
        return function () { return clearTimeout(timeoutHandler); };
    }, [needClearExpired]);
    return (React.createElement(ModalContext.Provider, { value: { openModal: openModal } },
        children,
        modalStates.map(function (_a) {
            var id = _a.id, show = _a.show, Modal = _a.Modal, resolve = _a.resolve;
            var onOk = function (result) {
                resolve(result);
                hideModal(id);
            };
            return (React.createElement(Modal, { key: id, show: show, onOk: onOk, onCancel: function () { return hideModal(id); } }));
        })));
};

export { ModalContext, ModalProvider };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 1018
// module chunks = 0